var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12"},[_c('px-card',{attrs:{"title":"Sales Purchase/ Return"}},[_c('div',{staticClass:"card-body report-sale"},[_c('apexchart',{attrs:{"type":"line","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }